import { useAction, useAtom } from '@reatom/npm-react'

import { useAppRoutes } from '@root/features/routing'

import { exploreNewPairsModel } from '../../atoms/reatom-explore-new'

import { ExploreList } from './explore-list'

import type { Pair } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type ExploreNewListProps = {
  onItemClick?: (options: { pair: Pair.PairMinimal }) => void
} & ClassNameProps

export const ExploreNewList: React.FC<ExploreNewListProps> = ({
  onItemClick,
}) => {
  const model = exploreNewPairsModel
  const [pairsState] = useAtom(model.resolvedPairsStateAtom)
  const load = useAction(model.load)
  const { navigateToTrading } = useAppRoutes()

  return (
    <ExploreList
      onItemClick={
        onItemClick
          ? onItemClick
          : ({ pair }) => navigateToTrading(pair.address, pair.network)
      }
      statsPeriod={model.period}
      priceChartInterval="seconds"
      onRetry={load}
      pairsState={pairsState}
    />
  )
}
